import { apiRequest } from '@/utils/api-request';
import { TestResult } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';

// Response type for test status endpoint
interface TestStatusResponse {
  status: 'completed' | 'incomplete';
}

export const getTestResults = async (id: string): Promise<TestResult[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<TestResult[]>({
    url: `/evaluations/test/runs/${orgId}/${id}`,
    target: 'platform',
    method: 'GET',
  });
  return response?.data as TestResult[];
};

// Check test run status
export const getTestRunStatus = async (
  testId: string,
  runId: string,
): Promise<TestStatusResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<TestStatusResponse>({
    url: `/evaluations/test/status/${orgId}/${testId}/${runId}`,
    target: 'platform',
    method: 'GET',
  });
  return response?.data as TestStatusResponse;
};

export const extractRunIdFromS3Key = (s3Key: string): string => {
  // Extract UUID from format like "4209e00d-6743-4c69-98cc-77a256f55548.json"
  const runId = s3Key.replace('.json', '');
  return runId;
};
